import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"color":"#18c75d","text-align":"center"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { style: {"color":"#e04055","text-align":"center"} }
const _hoisted_9 = {
  key: 2,
  style: {"text-align":"center"},
  class: "ion-padding"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", { class: "link-text-color" }, " Login", -1)
const _hoisted_12 = { style: {"margin":"auto","text-align":"center"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  style: {"cursor":"pointer"},
  class: "ion-color-medium"
}, "Datenschutz", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", { style: {"cursor":"pointer"} }, "AGB", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", { style: {"cursor":"pointer"} }, "Impressum", -1)
const _hoisted_18 = { style: {"margin":"auto","text-align":"center","padding-bottom":"15px","font-size":"7px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_verify_success_animation = _resolveComponent("verify-success-animation")!
  const _component_verify_error_animation = _resolveComponent("verify-error-animation")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_login_success_animation = _resolveComponent("login-success-animation")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_mobility_logo = _resolveComponent("mobility-logo")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-padding" }, {
        default: _withCtx(() => [
          ($setup.isEmailVerified)
            ? (_openBlock(), _createElementBlock("h1", {
                key: 0,
                class: "loginHeader",
                innerHTML: $setup.emailVerified
              }, null, 8, _hoisted_1))
            : (_openBlock(), _createElementBlock("h1", {
                key: 1,
                class: "loginHeader",
                innerHTML: $setup.emailVerify
              }, null, 8, _hoisted_2))
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "ion-padding" }, {
        default: _withCtx(() => [
          ($setup.isVerifyCheckDone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                ($setup.isEmailVerified)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_verify_success_animation, { style: {"max-height":"30rem","width":"100%","margin-bottom":"-1em","margin-top":"-1em"} }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString($setup.registerSuccessText), 1),
                          _hoisted_6,
                          _createTextVNode(_toDisplayString($setup.registerSucessGoBackToAppInfo), 1)
                        ])
                      ])
                    ]))
                  : (!$setup.isEmailVerified && !$setup.newResendLinkSend)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_verify_error_animation, { style: {"max-height":"30rem","width":"100%","margin-bottom":"-1em","margin-top":"-1em"} }),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", null, _toDisplayString($setup.registerErrorText), 1),
                          _createVNode(_component_ion_button, {
                            color: "danger",
                            expand: "block",
                            onClick: $setup.resendLink
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.verifyErrorResendLink) + " ", 1),
                              _createVNode(_component_ion_icon, {
                                class: "ion-padding-start",
                                icon: $setup.icons.mailOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    : ($setup.newResendLinkSend)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_login_success_animation, { style: {"max-height":"30rem","width":"100%","margin-bottom":"-1em","margin-top":"-1em"} }),
                          _createElementVNode("p", { innerHTML: $setup.registerSuccessBody }, null, 8, _hoisted_10),
                          _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString($setup.registerGoBackTo) + " ", 1),
                            _createVNode(_component_router_link, { to: "/login" }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { style: {"padding":"25px"} }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_12, [
            _createElementVNode("span", null, [
              _createVNode(_component_router_link, { to: "/privacy-crudafoch" }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _hoisted_14,
            _createElementVNode("span", null, [
              _createVNode(_component_router_link, { to: "/terms" }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            _hoisted_16,
            _createElementVNode("span", null, [
              _createVNode(_component_router_link, { to: "/impress" }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("p", _hoisted_18, " Version: " + _toDisplayString($setup.appVersion), 1),
          _createVNode(_component_mobility_logo)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}